import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout/Layout'
import { useParams } from 'react-router-dom';
import { convert } from '../../utils/convertDate';
import WakanowServices from '../../services/wakanowServices';
import BackButton from '../../components/BackButton';
import { FormatMoney } from '../../utils/formatMoney';

const statusColors = {
    'successful': 'bg-green-100 text-green-700',
    'initiated': 'bg-yellow-100 text-yellow-700',
    'failed': 'bg-red-100 text-red-700',
};

const ViewFlightBooking = () => {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response = await WakanowServices.getFlightBookingById(id);
                if (response) {
                    setData(response.data);
                }
            } catch (error) {
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, [id]);

    if (isLoading) {
        return (
            <Layout title="Flight Booking" pageTag={"wakanow"} current={'/wakanow/flight-bookings'}>
                <div className="min-h-full">
                    <div className="flex flex-1 flex-col">
                        <main className="flex-1">
                            <div className="py-6">
                                <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
                                    <div className="bg-white shadow sm:rounded-lg">
                                        <div className="px-4 py-5 sm:p-6">
                                            <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2">
                                                {Array.from({ length: 6 }).map((_, index) => (
                                                    <div key={index}>
                                                        <div className="h-4 bg-gray-200 rounded animate-pulse w-24 mb-2"></div>
                                                        <div className="h-10 bg-gray-200 rounded animate-pulse w-full"></div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </Layout>
        )
    }

    if (!data) {
        return (
            <Layout title="Flight Booking" pageTag={"wakanow"} current={'/wakanow/flight-bookings'}>
                <div className="text-center py-12">
                    <p className="text-gray-500">Flight booking not found</p>
                </div>
            </Layout>
        )
    }

    const statusClass = statusColors[data.bookingStatus?.toLowerCase()] || 'bg-gray-100 text-gray-600';

    return (
        <Layout title="Flight Booking" pageTag={"wakanow"} current={'/wakanow/flight-bookings'}>
            <React.Fragment>
                <div className="min-h-full">
                    <div className="flex flex-1 flex-col">
                        <BackButton />
                        <main className="flex-1">
                            <div className="py-6">
                                <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
                                    <div className="bg-white shadow overflow-hidden sm:rounded-lg">
                                        <div className="px-4 py-5 sm:p-6">
                                            <div className="flex items-center justify-between mb-6">
                                                <div>
                                                    <h2 className="text-xl font-bold text-gray-900">{data.bookingId}</h2>
                                                    <p className="text-sm text-gray-500 mt-1">Flight Booking</p>
                                                </div>
                                                <div className="flex items-center gap-3">
                                                    <span className={`px-3 py-1 text-sm font-semibold rounded-full shadow-sm ${statusClass}`}>
                                                        {data.bookingStatus}
                                                    </span>
                                                    {data.flightType && (
                                                        <span className="text-sm font-medium text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
                                                            {data.flightType}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-2 lg:grid-cols-3 mb-8">
                                                <div className="bg-gray-50 rounded-lg p-4">
                                                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Amount</p>
                                                    <p className="mt-1 text-lg font-bold text-gray-900">{FormatMoney(data.amount, "NGN")}</p>
                                                </div>
                                                <div className="bg-gray-50 rounded-lg p-4">
                                                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Transfer Reference</p>
                                                    <p className="mt-1 text-sm font-medium text-gray-900 break-all">{data.transferReference || 'N/A'}</p>
                                                </div>
                                                <div className="bg-gray-50 rounded-lg p-4">
                                                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Transfer Status</p>
                                                    <p className="mt-1 text-sm font-medium text-gray-900">{data.transferStatus || 'N/A'}</p>
                                                </div>
                                                <div className="bg-gray-50 rounded-lg p-4">
                                                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Payment Status</p>
                                                    <p className="mt-1 text-sm font-medium text-gray-900">{data.paymentStatus || 'N/A'}</p>
                                                </div>
                                                <div className="bg-gray-50 rounded-lg p-4">
                                                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Ticket Confirmation</p>
                                                    <p className="mt-1 text-sm font-medium text-gray-900">{data.ticketConfirmationStatus || 'N/A'}</p>
                                                </div>
                                                <div className="bg-gray-50 rounded-lg p-4">
                                                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Reversal Status</p>
                                                    <p className="mt-1 text-sm font-medium text-gray-900">{data.reversalStatus || 'N/A'}</p>
                                                </div>
                                                <div className="bg-gray-50 rounded-lg p-4">
                                                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">PNR Reference</p>
                                                    <p className="mt-1 text-sm font-medium text-gray-900">{data.pnrReferenceNumber || 'N/A'}</p>
                                                </div>
                                                <div className="bg-gray-50 rounded-lg p-4">
                                                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">PNR Status</p>
                                                    <p className="mt-1 text-sm font-medium text-gray-900">{data.pnrStatus || 'N/A'}</p>
                                                </div>
                                                <div className="bg-gray-50 rounded-lg p-4">
                                                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Ticket Status</p>
                                                    <p className="mt-1 text-sm font-medium text-gray-900">{data.ticketStatus || 'N/A'}</p>
                                                </div>
                                                <div className="bg-gray-50 rounded-lg p-4 sm:col-span-2 lg:col-span-3">
                                                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Session Email</p>
                                                    <p className="mt-1 text-sm font-medium text-gray-900">{data.sessionEmail || 'N/A'}</p>
                                                </div>
                                                <div className="bg-gray-50 rounded-lg p-4">
                                                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Date Created</p>
                                                    <p className="mt-1 text-sm font-medium text-gray-900">{data.dateCreated ? convert(data.dateCreated) : 'N/A'}</p>
                                                </div>
                                                <div className="bg-gray-50 rounded-lg p-4">
                                                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Date Modified</p>
                                                    <p className="mt-1 text-sm font-medium text-gray-900">{data.dateModified ? convert(data.dateModified) : 'N/A'}</p>
                                                </div>
                                            </div>

                                            {data.flightBookingDetails?.length > 0 && (
                                                <div>
                                                    <h3 className="text-lg font-semibold text-gray-900 mb-4">Flight Itinerary</h3>
                                                    <div className="overflow-x-auto">
                                                        <table className="min-w-full divide-y divide-gray-200">
                                                            <thead className="bg-gray-50">
                                                                <tr>
                                                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide">Airline</th>
                                                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide">From</th>
                                                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide">To</th>
                                                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide">Departure</th>
                                                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide">Arrival</th>
                                                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide">Duration</th>
                                                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide">Stops</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="bg-white divide-y divide-gray-200">
                                                                {data.flightBookingDetails.map((segment, idx) => (
                                                                    <tr key={idx} className="hover:bg-gray-50">
                                                                        <td className="px-4 py-3 text-sm font-medium text-gray-900 whitespace-nowrap">
                                                                            {segment.airlineName || segment.airline}
                                                                            <span className="text-gray-400 ml-1">({segment.airline})</span>
                                                                        </td>
                                                                        <td className="px-4 py-3 text-sm text-gray-700 whitespace-nowrap">
                                                                            <span className="font-medium">{segment.departureCode}</span>
                                                                            <span className="text-gray-400 ml-1">{segment.departureName}</span>
                                                                        </td>
                                                                        <td className="px-4 py-3 text-sm text-gray-700 whitespace-nowrap">
                                                                            <span className="font-medium">{segment.arrivalCode}</span>
                                                                            <span className="text-gray-400 ml-1">{segment.arrivalName}</span>
                                                                        </td>
                                                                        <td className="px-4 py-3 text-sm text-gray-700 whitespace-nowrap">
                                                                            {segment.departureTime ? convert(segment.departureTime) : 'N/A'}
                                                                        </td>
                                                                        <td className="px-4 py-3 text-sm text-gray-700 whitespace-nowrap">
                                                                            {segment.arrivalTime ? convert(segment.arrivalTime) : 'N/A'}
                                                                        </td>
                                                                        <td className="px-4 py-3 text-sm text-gray-700 whitespace-nowrap">
                                                                            {segment.tripDuration || segment.stopTime || 'N/A'}
                                                                        </td>
                                                                        <td className="px-4 py-3 text-sm text-gray-700 whitespace-nowrap">
                                                                            {segment.stops !== undefined && segment.stops !== null
                                                                                ? (segment.stops === 0 ? 'Non-stop' : `${segment.stops} stop${segment.stops > 1 ? 's' : ''}`)
                                                                                : 'N/A'}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </React.Fragment>
        </Layout>
    )
}

export default ViewFlightBooking
